module.exports = __webpack_public_path__ + "img/ER.bc34e97a.png";